import { DyteSpinner } from "@dytesdk/react-ui-kit";

function MeetingLoading() {
  /**
   * NOTE(ravindra-dyte): Don't like the default spinner?
   * You can replace DyteSpinner with your own screen, here.
   */
  return (
    <div className="h-full flex flex-col justify-center items-center">
      <DyteSpinner />
      <p className="text-gray-500">Starting session...</p>
    </div>
  );
}

export default MeetingLoading;
